module.exports = __webpack_public_path__ + "img/level.a11daae4.png";